import { render, staticRenderFns } from "./DownloadOrder.vue?vue&type=template&id=6fc4d249"
import script from "./DownloadOrder.vue?vue&type=script&lang=js"
export * from "./DownloadOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports